import require$$0, { Component, Children } from "react";
var slider = "";
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;
function toObject(val) {
  if (val === null || val === void 0) {
    throw new TypeError("Object.assign cannot be called with null or undefined");
  }
  return Object(val);
}
function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    }
    var test1 = new String("abc");
    test1[5] = "de";
    if (Object.getOwnPropertyNames(test1)[0] === "5") {
      return false;
    }
    var test2 = {};
    for (var i = 0; i < 10; i++) {
      test2["_" + String.fromCharCode(i)] = i;
    }
    var order2 = Object.getOwnPropertyNames(test2).map(function(n2) {
      return test2[n2];
    });
    if (order2.join("") !== "0123456789") {
      return false;
    }
    var test3 = {};
    "abcdefghijklmnopqrst".split("").forEach(function(letter) {
      test3[letter] = letter;
    });
    if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") {
      return false;
    }
    return true;
  } catch (err) {
    return false;
  }
}
shouldUseNative() ? Object.assign : function(target, source) {
  var from;
  var to = toObject(target);
  var symbols;
  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);
    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }
    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);
      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }
  return to;
};
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f = require$$0, g = 60103;
reactJsxRuntime_production_min.Fragment = 60107;
if (typeof Symbol === "function" && Symbol.for) {
  var h = Symbol.for;
  g = h("react.element");
  reactJsxRuntime_production_min.Fragment = h("react.fragment");
}
var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
function q(c, a, k) {
  var b, d = {}, e = null, l = null;
  k !== void 0 && (e = "" + k);
  a.key !== void 0 && (e = "" + a.key);
  a.ref !== void 0 && (l = a.ref);
  for (b in a)
    n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
  if (c && c.defaultProps)
    for (b in a = c.defaultProps, a)
      d[b] === void 0 && (d[b] = a[b]);
  return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
}
reactJsxRuntime_production_min.jsx = q;
reactJsxRuntime_production_min.jsxs = q;
{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}
const jsx = jsxRuntime.exports.jsx;
const jsxs = jsxRuntime.exports.jsxs;
const Fragment = jsxRuntime.exports.Fragment;
const NavButton = ({
  onClick,
  disabled,
  visible,
  className,
  arrow = "<"
}) => /* @__PURE__ */ jsx("button", {
  onClick,
  disabled,
  type: "button",
  className: ["slider__btn", className, visible && "visible"].join(" "),
  children: arrow
});
class Slider extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      prevButtonVisible: true,
      nextButtonVisible: true,
      prevButtonDisabled: false,
      nextButtonDisabled: false
    };
    this._mounted = false;
    this.scroller = null;
    this.slider = null;
    this.items = [];
    this.renderContent = () => /* @__PURE__ */ jsx("div", {
      className: "slider__scroller",
      onScroll: this.checkShowButtons,
      ref: (scroller) => this.scroller = scroller,
      children: /* @__PURE__ */ jsx("div", {
        className: "slider__body",
        children: Children.map(this.props.children, (child, i) => child ? /* @__PURE__ */ jsx("div", {
          ref: (el) => this.items[i] = el,
          className: "slider__item",
          children: child
        }) : null)
      })
    });
    this.checkShowButtons = () => {
      if (!this.scroller) {
        return;
      }
      const {
        offsetWidth,
        scrollLeft,
        scrollWidth
      } = this.scroller;
      this.setState({
        nextButtonVisible: scrollWidth - offsetWidth > 0 && scrollLeft + offsetWidth < scrollWidth,
        prevButtonVisible: scrollWidth - offsetWidth > 0 && scrollLeft > 0,
        scrollWidth
      });
    };
    this.checkScrollNext = () => {
      if (!this.scroller || !this.items || !this.items.length) {
        return;
      }
      const scrollerVisibleWidth = this.scroller.offsetWidth;
      const scrollerScrollLeft = this.scroller.scrollLeft;
      const scrollerScrollRight = scrollerScrollLeft + scrollerVisibleWidth;
      const itemsWidths = Object.values(this.items).map((item) => item ? item.offsetWidth : 0);
      const itemsOffsetLeft = Object.values(this.items).map((item) => item ? item.offsetLeft : 0);
      const nextItemIndex = getNextItem(scrollerScrollLeft, scrollerScrollRight, itemsWidths);
      const scrollerWidth = this.scroller.scrollWidth;
      const possibleScroll = scrollerWidth - scrollerVisibleWidth + 1;
      const nextItem = nextItemIndex !== this.items.length ? itemsOffsetLeft[nextItemIndex] : null;
      function getNextItem(left, right, widths) {
        let availableWidth = 0, visibleWidth = 0, i = 0;
        do {
          availableWidth += widths[i];
          i++;
        } while (right >= availableWidth && i < widths.length);
        i = i - 1;
        for (let j = 0; j < i; j++) {
          visibleWidth += widths[j];
        }
        return visibleWidth <= left ? i + 1 : i;
      }
      if (!nextItem || possibleScroll < nextItem || nextItemIndex === this.items.length) {
        this.prepareScrolling(possibleScroll);
      } else {
        this.prepareScrolling(nextItem);
      }
    };
    this.getFirstVisible = function(scrollLeft, widths) {
      let first = 0, i = 0;
      while (first < scrollLeft) {
        first += widths[i];
        i++;
      }
      return i;
    };
    this.getPrevItem = function(visibleScroll, firstVisible, widths) {
      let i = firstVisible, possible = 0;
      if (widths[i - 1] >= visibleScroll) {
        return i - 1;
      } else {
        do {
          i--;
          possible += widths[i];
        } while (possible < visibleScroll && i > -1);
        return i + 1;
      }
    };
    this.checkScrollPrevious = () => {
      if (!this.scroller) {
        return;
      }
      const scrollerVisibleWidth = this.scroller.offsetWidth;
      const scrollerScrollLeft = this.scroller.scrollLeft;
      const itemsWidths = Object.values(this.items).map((item) => item.offsetWidth);
      const firstVisible = this.getFirstVisible(scrollerScrollLeft, itemsWidths);
      const prevItemIndex = this.getPrevItem(scrollerVisibleWidth, firstVisible, itemsWidths);
      const itemsOffsetLeft = Object.values(this.items).map((item) => item ? item.offsetLeft : 0);
      const nextItem = itemsOffsetLeft[prevItemIndex];
      this.prepareScrolling(nextItem);
    };
    this.easeInOutQuad = (t, b, c, d) => {
      t /= d / 2;
      if (t < 1)
        return c / 2 * t * t + b;
      t--;
      return -c / 2 * (t * (t - 2) - 1) + b;
    };
  }
  componentDidMount() {
    this._mounted = true;
    window.addEventListener("resize", this.checkShowButtons);
    this.checkShowButtons();
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.scroller && this.scroller.scrollWidth !== prevState.scrollWidth) {
      this.checkShowButtons();
    }
    if (Children.toArray(prevProps.children).length !== Children.toArray(this.props.children).length) {
      this.items = [];
    }
  }
  componentWillUnmount() {
    this._mounted = false;
    window.removeEventListener("resize", this.checkShowButtons);
  }
  render() {
    return /* @__PURE__ */ jsx("div", {
      className: "slider",
      ref: (slider2) => this.slider = slider2,
      children: typeof this.props.render == "function" ? this.props.render({
        content: this.renderContent(),
        prevButton: (arrow) => /* @__PURE__ */ jsx(NavButton, {
          onClick: this.checkScrollPrevious,
          disabled: this.state.prevButtonDisabled,
          visible: this.state.prevButtonVisible,
          arrow,
          className: "slider__btn--left"
        }),
        nextButton: (arrow) => /* @__PURE__ */ jsx(NavButton, {
          onClick: this.checkScrollNext,
          disabled: this.state.nextButtonDisabled,
          visible: this.state.nextButtonVisible,
          arrow,
          className: "slider__btn--right"
        })
      }) : /* @__PURE__ */ jsxs(Fragment, {
        children: [/* @__PURE__ */ jsx(NavButton, {
          onClick: this.checkScrollPrevious,
          disabled: this.state.prevButtonDisabled,
          visible: this.state.prevButtonVisible,
          className: "slider__btn--left"
        }), this.renderContent(), /* @__PURE__ */ jsx(NavButton, {
          onClick: this.checkScrollNext,
          disabled: this.state.nextButtonDisabled,
          visible: this.state.nextButtonVisible,
          className: "slider__btn--right"
        })]
      })
    });
  }
  prepareScrolling(offsetLeft) {
    if (!this.scroller) {
      return;
    }
    const start = this.scroller.scrollLeft;
    const distance = offsetLeft - start;
    this.animateScrolling(start, distance);
    this.setState({
      nextButtonDisabled: true,
      prevButtonDisabled: true
    });
    setTimeout(() => this._mounted && this.setState({
      nextButtonDisabled: false,
      prevButtonDisabled: false
    }), this.props.duration + 50);
  }
  animateScrolling(start, distance) {
    let currentTime = 0;
    const increment = 20;
    const doScroll = () => {
      currentTime += increment;
      if (this.scroller) {
        this.scroller.scrollLeft = this.easeInOutQuad(currentTime, start, distance, this.props.duration);
      }
      if (currentTime < this.props.duration) {
        setTimeout(doScroll, increment);
      }
    };
    doScroll();
  }
}
Slider.defaultProps = {
  duration: 300
};
export { Slider, Slider as default };
